// Cross-bundle request cache for `GET api/stores`. The Vue 2 and Vue 3
// bundles each compile their own copy of this module (separate module
// graphs), so the promise is pinned on globalThis — whichever bundle fetches
// first owns the request, the other reuses it. The fetcher is passed in
// because each bundle has its own axios instance.
// A failed fetch is not cached, so the next caller retries.
const KEY = '__STORE_LIST_REQUEST__'

export const sharedStoreListFetch = (fetcher, force = false) => {
  if (globalThis[KEY] && !force) return globalThis[KEY]

  const request = Promise.resolve()
    .then(fetcher)
    .catch((error) => {
      if (globalThis[KEY] === request) globalThis[KEY] = undefined
      throw error
    })

  globalThis[KEY] = request
  return request
}
